// extracted by mini-css-extract-plugin
export default {"locationContainer":"LocationProfile_locationContainer__dH99i","locationText":"LocationProfile_locationText__KhnCl","locationName":"LocationProfile_locationName__IXBEE"};